import { createActions } from 'redux-actions';

const actions = createActions({
  SESSION: {
    CLEAR_SESSION: undefined
  }
})

const configuration = {
  name: 'clearSession',
  action: actions,
  sagas: undefined,
  reducers: {
    reducer: (state, action) => ({
      ...state,
      isLoggingIn: false,
      isLoggingOut: false,
      isAuthenticated: false,
      userId: null,
      idToken: null,
      message: null
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/session/configurations/clearSession.js